export default {"src":"/_next/static/media/bat-own.95b53b4a.svg","height":100,"width":100};